export default "__VITE_ASSET__BSWmGwxh__"